import { useSelector } from "react-redux"
import { selectNotificationList } from "../../../../store/slices/notificationSlice"


export const useNotificationList = ()=>{
const list = useSelector(selectNotificationList)

    return {list}
}